import React from 'react';

import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router';

import AppRoute from 'components/Routes/AppRoute';
// import AuthRoute from 'components/Routes/AuthRoute';
import ErrorScreen from 'components/shared/ErrorScreen';
import { useGTM } from 'hooks/useGTM';
import { usePrivacyPolicy } from 'hooks/usePrivacyPolicy';
import { guestPortalAuthFlowSelector, guestPortalIdSelector } from 'store/app/selectors';
import { itineraryAccountGtmContainerSelector } from 'store/itinerariesItem/selectors';
import { checkIsDeactivatedError } from 'utils/error';

// import VerificationPage from '../../GuestPortalAccess/Auth/VerificationPage';
import GuestPortalAuthFlowSetter from '../../GuestPortalAccess/GuestPortalAuthFlowSetter';
// import AuthContainerLayout from '../Auth/Layout';
// import ResetPassword from '../Auth/ResetPassword';
import Dashboard from '../Dashboard';
import ForbiddenGuestPortal from '../ForbiddenGuestPortal';
import LandingLayout from '../LandingLayout';
import PrivacyPolicy from '../PrivacyPolicy';
// import AuthRoutes from './AuthRoutes';
import {
  GP_ROOT_ROUTE,
  GP_LANDING_ROUTE,
  GP_FORBIDDEN_GP_ROUTE,
  GP_PRIVACY_POLICY_ROUTE,
  GP_AUTH_SIGNIN_ROUTE,
} from './constants';
import { useGPViewed, useGuestPortalRouteBuilder, useRedirectUrlForGettingShowMobileInfo } from './functions';

function InnerRoutes() {
  useGPViewed();
  const guestPortalId = useSelector(guestPortalIdSelector);
  usePrivacyPolicy(guestPortalId);

  const gtmContainerId = useSelector(itineraryAccountGtmContainerSelector);
  useGTM(gtmContainerId);

  return (
    <Switch>
      <Route path={GP_LANDING_ROUTE} component={LandingLayout} />
      <Route path={GP_ROOT_ROUTE} exact component={Dashboard} />
      <Route>
        <ErrorScreen status="404_guest" />
      </Route>
    </Switch>
  );
}

export function GuestPortalRoutes() {
  const { buildRoute } = useGuestPortalRouteBuilder();
  const guestPortalId = useSelector(guestPortalIdSelector);
  const { failureReason } = usePrivacyPolicy(guestPortalId);

  if (failureReason?.errors && checkIsDeactivatedError(failureReason.errors)) {
    const { errors } = failureReason;

    return (
      <ErrorScreen
        status={errors.title}
        buttonText="Contact"
        coverImage={errors.coverImage}
        buttonAction={(e) => {
          e.preventDefault();
          window.location.href = `mailto: ${errors.email}`;
        }}
        hideStatusCode
      />
    );
  }

  return (
    <Switch>
      <Route path={GP_FORBIDDEN_GP_ROUTE} exact component={ForbiddenGuestPortal} />

      <AppRoute getSignInPath={() => GP_AUTH_SIGNIN_ROUTE} getDeletedPath={() => buildRoute(GP_FORBIDDEN_GP_ROUTE)}>
        <InnerRoutes />
      </AppRoute>
    </Switch>
  );
}

function GuestPortalFlowDetector() {
  const guestPortalAuthFlow = useSelector(guestPortalAuthFlowSelector);

  if (guestPortalAuthFlow === null) {
    return <GuestPortalAuthFlowSetter />;
  }

  return <GuestPortalRoutes />;
}

function GuestPortalRootRoutes() {
  useRedirectUrlForGettingShowMobileInfo();

  return (
    <Switch>
      <Route path={GP_PRIVACY_POLICY_ROUTE} exact>
        <PrivacyPolicy />
      </Route>

      <Route path={GP_ROOT_ROUTE}>
        <GuestPortalFlowDetector />
      </Route>

      <Route>
        <ErrorScreen status="404_guest" />
      </Route>
    </Switch>
  );
}

export default GuestPortalRootRoutes;
